import { render, staticRenderFns } from "./SolutionPurchaseReceipt.vue?vue&type=template&id=180e8e92&scoped=true&"
import script from "./SolutionPurchaseReceipt.vue?vue&type=script&lang=js&"
export * from "./SolutionPurchaseReceipt.vue?vue&type=script&lang=js&"
import style0 from "./SolutionPurchaseReceipt.vue?vue&type=style&index=0&id=180e8e92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e8e92",
  null
  
)

export default component.exports